import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { RestService } from "../../services/rest.service";
import { FormdataService } from "../../services/formdata.service";
import {
  FormControl,
  FormGroup,
  Validators,
  ValidationErrors
} from "@angular/forms";

@Component({
  selector: "app-profile-shell-profile-tab",
  templateUrl: "./profile-shell-profile-tab.component.html",
  styleUrls: ["./profile-shell-profile-tab.component.scss"]
})
export class ProfileShellProfileTabComponent implements OnInit {
  public disty_data: any = {
    address_city: "",
    address_country: "",
    address_country_code: "",
    address_line_one: "",
    address_line_two: "",
    address_postal_code: "",
    address_state_province: "",
    address_zip: "",
    contact_email: "",
    contact_first_name: "",
    contact_last_name: "",
    contact_phone: "",
    bill_to_name: "",
    bill_to_address_line_one: "",
    bill_to_address_line_two: "",
    bill_to_city: "",
    bill_to_state_province: "",
    bill_to_zip: "",
    bill_to_country: "",
    currency: "",
    email: "",
    inco_terms: "",
    internal_id: "",
    legal_name: "",
    parent_id: "",
    primary_contact_id: "",
    supplier_legal_name: "",
    supplier_address_line_one: "",
    supplier_address_line_two: "",
    supplier_address_city: "",
    supplier_address_state_province: "",
    supplier_address_postal_code: "",
    supplier_address_country_code: "",
    supplier_seller_id: "",
    supplier_phone_number: "",
    supplier_email: "",
    terms: "",
    governing_law: ""
  };

  form = new FormGroup({
    legal_name: new FormControl("", Validators.required),
    address_country: new FormControl("", Validators.required),
    address_line_one: new FormControl("", Validators.required),
    address_line_two: new FormControl(""),
    address_city: new FormControl("", Validators.required),
    address_state_province: new FormControl("", Validators.required),
    address_zip: new FormControl("", Validators.required),
    customer_reference_number: new FormControl("", Validators.required),
    internal_id: new FormControl(""),
    parent_id: new FormControl(""),
    primary_contact_id: new FormControl("", Validators.required),
    first_name: new FormControl(""),
    last_name: new FormControl(""),
    phone_number: new FormControl(""),
    email: new FormControl(""),
    bill_to_name: new FormControl("", Validators.required),
    bill_to_address_line_one: new FormControl("", Validators.required),
    bill_to_address_line_two: new FormControl(""),
    bill_to_city: new FormControl("", Validators.required),
    bill_to_state_province: new FormControl("", Validators.required),
    bill_to_zip: new FormControl("", Validators.required),
    bill_to_country: new FormControl("", Validators.required),
    supplier_address_country_code: new FormControl("", Validators.required),
    supplier_address_line_one: new FormControl("", Validators.required),
    supplier_address_state_province: new FormControl("", Validators.required),
    supplier_address_city: new FormControl("", Validators.required),
    supplier_address_postal_code: new FormControl("", Validators.required),
    supplier_email: new FormControl("", Validators.required),
    supplier_phone_number: new FormControl("", Validators.required),
    supplier_legal_name: new FormControl("", Validators.required),
    supplier_seller_id: new FormControl("", Validators.required),
    currency: new FormControl("", Validators.required),
    terms: new FormControl("", Validators.required),
    inco_terms: new FormControl("", Validators.required),
    governing_law: new FormControl("", Validators.required)
  });

  constructor(
    private rest: RestService,
    public auth: AuthService,
    public formdata: FormdataService
  ) {}
  state_provinces = [];
  has_state_provinces = true;
  successfully_updated = false;
  errorMessage = "";
  successMessage = "";
  contacts: any = [];
  displayContact: any = {
    first_name: "",
    last_name: "",
    phone_number: "",
    email: ""
  };
  form_is_valid = false;

  fieldIsRequired(field) {
    return this.form.controls[field].validator !== null;
  }

  chooseCountry(event) {
    console.log("choosing");
    console.log(event.target.value);
    this.populate_state_provinces(event.target.value.slice(-2));
  }

  populate_state_provinces(country_code) {
    const country = this.formdata.countries.find(c => c.code === country_code);
    if (country) {
      this.state_provinces = country.states;
      this.has_state_provinces = true;
    } else {
      this.state_provinces = [];
      this.has_state_provinces = false;
    }
  }

  ngOnInit() {
    this.refreshPageData();
  }

  refreshPageData() {
    // 1. Get disty data
    const cust_id = this.auth.getCustId();
    this.rest.getDistyDataForManagement(cust_id).subscribe(
      data => {
        this.errorMessage = "";
        this.disty_data = data;
        this.form.valueChanges.subscribe(_data => {
          [
            "legal_name",
            "address_country",
            "address_line_one",
            "address_line_two",
            "address_city",
            "address_state_province",
            "address_zip",
            "customer_reference_number",
            "internal_id",
            "parent_id",
            "primary_contact_id",
            "first_name",
            "last_name",
            "phone_number",
            "email",
            "bill_to_name",
            "bill_to_address_line_one",
            "bill_to_address_line_two",
            "bill_to_city",
            "bill_to_state_province",
            "bill_to_zip",
            "bill_to_country",
            "supplier_address_country_code",
            "supplier_address_line_one",
            "supplier_address_state_province",
            "supplier_address_city",
            "supplier_address_postal_code",
            "supplier_email",
            "supplier_phone_number",
            "supplier_legal_name",
            "supplier_seller_id",
            "currency",
            "terms",
            "inco_terms",
            "governing_law"
          ].forEach(field => {
            const formField = this.form.get(field);
            const value =
              formField == null || formField === undefined
                ? ""
                : formField.value;
            this.disty_data[field] = value;
            // TODO: loop through errors here:
            // const controlErrors : ValidationErrors = this.form.get(field)
            // use this: https://stackoverflow.com/questions/40680321/get-all-validation-errors-from-angular-2-formgroup
          });
          console.log("THIS FORM ERRORS");
          // console.log();
          Object.keys(this.form.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.form.get(key).errors;
            if (controlErrors != null) {
              console.log("NOT NULL: " + key);
              Object.keys(controlErrors).forEach(keyError => {
                console.log(
                  "Key control: " +
                    key +
                    ", keyError: " +
                    keyError +
                    ", err value: ",
                  controlErrors[keyError]
                );
              });
            }
          });

          this.form_is_valid = this.form.valid;
        });
        /* This is causing the tests to fail
        this.form.setValue({
              legal_name: this.disty_data.legal_name
            , address_country: this.disty_data.address_country
            , address_line_one: this.disty_data.address_line_one
            , address_line_two: this.disty_data.address_line_two
            , address_city: this.disty_data.address_city
            , address_state_province: this.disty_data.address_state_province
            , address_zip: this.disty_data.address_zip
            , customer_reference_number: this.disty_data.customer_reference_number
            , internal_id: this.disty_data.internal_id
            , parent_id: this.disty_data.parent_id
            , primary_contact_id: this.disty_data.primary_contact_id
            , first_name: this.disty_data.contact_first_name
            , last_name: this.disty_data.contact_last_name
            , phone_number: this.disty_data.contact_phone
            , email: this.disty_data.contact_email
            , bill_to_name: this.disty_data.bill_to_name
            , bill_to_address_line_one: this.disty_data.bill_to_address_line_one
            , bill_to_address_line_two: this.disty_data.bill_to_address_line_two
            , bill_to_city: this.disty_data.bill_to_city
            , bill_to_state_province: this.disty_data.bill_to_state_province
            , bill_to_zip: this.disty_data.bill_to_zip
            , bill_to_country: this.disty_data.bill_to_country
            , supplier_address_country_code: this.disty_data.supplier_address_country_code
            , supplier_address_line_one: this.disty_data.supplier_address_line_one
            , supplier_address_state_province: this.disty_data.supplier_address_state_province
            , supplier_address_city: this.disty_data.supplier_address_city
            , supplier_address_postal_code: this.disty_data.supplier_address_postal_code
            , supplier_email: this.disty_data.supplier_email
            , supplier_phone_number: this.disty_data.supplier_phone_number
            , supplier_legal_name: this.disty_data.supplier_legal_name
            , supplier_seller_id: this.disty_data.supplier_seller_id
            , currency: this.disty_data.currency
            , terms: this.disty_data.terms
            , inco_terms: this.disty_data.inco_terms
            , governing_law: this.disty_data.governing_law
        });
*/

        this.populate_state_provinces(this.disty_data.address_country);
        this.rest.getUsersForMyDistributorEntity().subscribe(resp => {
          this.contacts = resp;
          this.changeContact();
        });
      },
      error => {
        this.errorMessage = "No data returned from server";
      }
    );
  }

  changeContact() {
    console.log(this.disty_data.primary_contact_id);
    if (this.disty_data.primary_contact_id) {
      this.displayContact = this.contacts.filter(
        contact => contact.id === this.disty_data.primary_contact_id
      )[0];
      this.form.controls["first_name"].setValue(this.displayContact.first_name);
      this.form.controls["last_name"].setValue(this.displayContact.last_name);
      this.form.controls["phone_number"].setValue(
        this.displayContact.phone_number
      );
      this.form.controls["email"].setValue(this.displayContact.email);
    } else {
      this.displayContact = {
        first_name: "",
        last_name: "",
        phone_number: "",
        email: ""
      };
    }
  }
}
